import { gql } from '@apollo/client';

export const REMOVE_PHOTO = gql`
  mutation DeletePhoto($input: DeletePhotoInput!) {
    deletePhoto(input: $input)
  }
`;
